module.exports = __webpack_public_path__ + "static/fonts/Inter-SemiBold.07a48beb.ttf";